import { useState } from 'react';
import { Button, Heading, Sheet, SheetContent } from '@/components/atoms';
import {
  PageHeader,
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from '@/components/molecules';
import { Plus } from 'lucide-react';
import {
  ShippingCreationForm,
  AllShippingMethods,
  AllPickupLocations,
  PickupLocationForm,
} from './components';

export const ShippingPage = () => {
  const [activeTab, setActiveTab] = useState('shipping');
  const [id, setId] = useState<number>();
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState<'update' | 'create'>('create');

  const [pickupSheetOpen, setPickupSheetOpen] = useState(false);
  const [pickupId, setPickupId] = useState<number>();
  const [pickupMode, setPickupMode] = useState<'update' | 'create'>('create');

  const toggleOpen = () => setOpen((prev) => !prev);
  const togglePickupOpen = () => setPickupSheetOpen((prev) => !prev);

  const handleOpenPickupCreate = () => {
    setPickupMode('create');
    setPickupId(undefined);
    togglePickupOpen();
  };

  const handleOpenPickupEdit = (editId: number) => {
    setPickupMode('update');
    setPickupId(editId);
    togglePickupOpen();
  };

  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        heading="Shipping & pickup"
        description="Manage shipping methods and pickup locations."
      />

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <TabsList>
            <TabsTrigger value="shipping">Shipping methods</TabsTrigger>
            <TabsTrigger value="pickup">Pickup locations</TabsTrigger>
          </TabsList>
          {activeTab === 'shipping' ? (
            <Button
              onClick={() => {
                setMode('create');
                toggleOpen();
              }}
            >
              <Plus />
              Add Shipping Method
            </Button>
          ) : (
            <Button onClick={handleOpenPickupCreate}>
              <Plus />
              Add pickup location
            </Button>
          )}
        </div>

        <TabsContent value="shipping" className="mt-6">
          <AllShippingMethods
            toggleOpen={toggleOpen}
            setMode={setMode}
            setId={setId}
          />
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetContent className="max-sm:w-screen overflow-y-auto pt-10 pb-4 px-4">
              <Heading size="xl">
                {mode === 'create' ? 'Create' : 'Update'} Shipping Method
              </Heading>
              <ShippingCreationForm
                id={id}
                mode={mode}
                toggleOpen={toggleOpen}
              />
            </SheetContent>
          </Sheet>
        </TabsContent>

        <TabsContent value="pickup" className="mt-6">
          <AllPickupLocations
            onAdd={handleOpenPickupCreate}
            onEdit={handleOpenPickupEdit}
          />
          <Sheet open={pickupSheetOpen} onOpenChange={setPickupSheetOpen}>
            <SheetContent className="max-sm:w-screen overflow-y-auto pt-10 pb-4 px-4">
              <Heading size="xl">
                {pickupMode === 'create' ? 'Add' : 'Edit'} Pickup location
              </Heading>
              <PickupLocationForm
                id={pickupId}
                mode={pickupMode}
                onSuccess={togglePickupOpen}
              />
            </SheetContent>
          </Sheet>
        </TabsContent>
      </Tabs>
    </div>
  );
};
